<template>
    <div id="category">
        <Header />
        <div class="menu">
            <div class="container">
                <ul>
                    <li v-for="(item, index) in categoryList" :key="index" :class="{'on' : currCategoryIdx === item.idx}">
                        <router-link tag="a" :to="'/Category/' + item.idx+ '/' + searchText">
                            {{item.name}}
                        </router-link>
                    </li>
                </ul>
            </div>
        </div>
        <div class="container">
            <!-- <select>
                <option>인기순</option>
                <option>업데이트순</option>
            </select> -->
            <div class="search_line">
                <input type="text" v-model="searchText" placeholder="작품/작가명을 입력해주세요" @keyup.enter="search" id="inputSearch">
                <img src="../assets/images/icon_search_cancel.svg" v-if="searchText.length > 0" @click="searchText = ''" class="btn-clear"/>
                <img src="../assets/images/icon_search_black.svg" class="btn-search" @click="search" />
            </div>
            <p class="total">총 {{totalRecordSize}} 작품</p>
            <p class="no-search" v-if="totalRecordSize <= 0">검색된 작품이 없습니다.</p>
            <b-row tag="div" cols="5" sm="2" md="5">
                <b-col tag="div" v-for="(item, index) in categoryWebtoonList" :key="index" @click="moveDetail(item)">
                    <img src="../assets/images/adult_mark.svg" alt="성인 마크" class="adult_mark" v-if="item.adult === 1">
                    <div class="top">
                        <img :src="siteConfig.cdnUrl + '/KR/title/' + item.englishName + '.jpg'">
                    </div>
                    <div class="middle">
                        <p class="name">{{item.titleName}}</p>
                        <!-- <p class="up_check">UP</p> -->
                    </div>
                    <div class="bottom">
                        <p>{{item.publisher}}</p>
                        <!-- <p class="view">{{item.viewTotal}} 회</p> -->
                    </div>
                </b-col>
            </b-row>
            <div class="paging" v-if="totalRecordSize > 0">
                <a @click="prevPage()"><img src="../assets/images/arrow_left.svg" /></a>
                <a class="current" v-if="pageList.length <= 0">1</a>
                <a v-for="(item, index) in pageList" :key="index" :class="{'current' : item === currentPageNo}" @click="movePage(item)">{{item}}</a>
                <a @click="nextPage()"><img src="../assets/images/arrow_right.svg" /></a>
            </div>
        </div>
        <Footer />
        <Login :initIsShowPopup="isShowLoginPopup" @close="close('Login')" />
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Login from '@/components/Login.vue'

export default {
    name: 'Home',
    pageCategory: '',
    components: {
        Header,
        Footer,
        Login,

    },
    data() {
        return {
            currCategoryIdx: 0,
            currScending: 0,
            currSort: 0,

            categoryList: [],
            categoryWebtoonList: [],

            searchText: '',

            currentPageNo: 1,      //현재 페이지 번호
            currentPageSize: 10,    //한번에 불러올 게시물 수
            maxPageCount:10,        //한 화면에 보여질 페이지 수

            listCount: 0,
            pageCount: 0,
            pageNo: 0,
            pageSize: 0,
            totalRecordSize: 0,

            pageList:[],

            isShowLoginPopup: false,
        }
    },
    async created(){
        await this.mixinSiteConfigCheck();

        if(this.$route.params.idx){
            this.currCategoryIdx = Number(this.$route.params.idx);
        }
        if(this.$route.params.searchText){
            this.searchText = this.$route.params.searchText;
        }

        this.getCategory();
        // this.getCategoryWebtoonList();
        this.getSearchList();

    },
    mounted(){
        document.getElementById('inputSearch').focus();
    },
    methods: {
        prevPage(){
            if(this.currentPageNo > 1){
                this.currentPageNo--;
                this.getCategoryWebtoonList();
            }
        },
        nextPage(){
            if(this.currentPageNo < this.pageCount){
                this.currentPageNo++;
                this.getCategoryWebtoonList();
            }
        },
        movePage(no){
            if(this.currentPageNo === no)
                return;

            this.currentPageNo = no;
            this.getCategoryWebtoonList();
        },
        changePage(){
            this.pageList = [];
            if(this.pageCount === 0)
                return;

            var tmpPageNo = this.currentPageNo - 2;
            if(this.currentPageNo + 2 > this.pageCount){
                tmpPageNo--;
            }
            if(this.currentPageNo +1 > this.pageCount){
                tmpPageNo--;
            }
            for(var i=0; i<5 && tmpPageNo <= this.pageCount; ){
                if(tmpPageNo >= 1){
                    this.pageList.push(tmpPageNo);
                    i++;
                }
                tmpPageNo++;   
            }
        },
        getCategory(){ // 카테고리 정보
            var param = 
            {
                // limit : 3
            }
            this.$Axios.post(`${this.host}/infocategory`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                if (res.data.returnCode === 0) {
                    // console.log(res.data)
                    this.categoryList = res.data.list;
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getCategoryName(category_idx){
            var name = '';
            this.categoryList.forEach(element =>{
                if(category_idx === element.idx){
                    name = element.name;
                }
            })
            return name;
        },
        search(){
            this.$router.push('/Category/' + this.currCategoryIdx + '/' + this.searchText);
        },
        getCategoryWebtoonList(){
            var param = 
            {   
                category: this.currCategoryIdx,
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                scending: this.currScending,
                sort: this.currSort,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0
            }
            this.$Axios.post(`${this.host}/webtoon/category`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.categoryWebtoonList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        getSearchList(){
            var param = 
            {
                pageNo: this.currentPageNo,
                pageSize: this.currentPageSize,
                // scending: this.currScending,
                // sort: this.currSort,
                sign: this.$store.state.sign,
                ticket: this.$store.state.ticket,
                viewAdult: this.$store.state.isCheckedAdult ? 1 : 0,
                category: this.currCategoryIdx,
                word: this.searchText,
            }
            this.$Axios.post(`${this.host}/search`, param, { headers: { 'Pragma' : 'no-cache', 'Cache-Control': 'no-cache', 'Access-Control-Allow-Origin': '*', 'Content-type': 'application/json', }}).then(res => {
                // console.log(res.data);
                if (res.data.returnCode === 0) {
                    this.categoryWebtoonList = res.data.list;
                    this.listCount       = res.data.page.listCount;
                    this.pageCount       = res.data.page.pageCount;
                    this.pageNo          = res.data.page.pageNo;
                    this.pageSize        = res.data.page.pageSize;
                    this.totalRecordSize = res.data.page.totalRecordSize;
                    this.changePage();
                }
            })
            .catch((error) => {
                console.log(error);
            });
        },
        moveDetail(item){
            
            if(item.adult === 1){
                if(this.$store.state.loginCheck === false){
                    this.isShowLoginPopup = true;
                }
                else if(!this.$store.state.adult){
                    var src = this.siteConfig.niceUrl + '?email=' + this.$store.state.email;
                    window.open(src, 'popupChk', 'width=500, height=550, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=no, location=no, scrollbar=no');
                }
                else{
                    // this.$router.push('/Toondetail/' + item.englishName);
                    this.$router.push('/Toondetail/' + item.webToonIndex);
                }
            }else{
                // this.$router.push('/Toondetail/' + item.englishName);
                this.$router.push('/Toondetail/' + item.webToonIndex);
            }
            
        },
        close(popupType){
            switch(popupType){
                case 'Login':
                    this.isShowLoginPopup = false;
                    break;
            }
        }
    }
}
</script>